import { useAtomValue } from 'jotai';
import React, { useEffect, useState } from 'react';
import { legendTableAtom, menuAtom, selectedLayersAtom, selectedSubMapLayersAtom } from '../../atoms';
import { walkCategories } from '../../lib/urlEncoding';
import { anyType } from '../../types';
import LegendIcon from '../legendIcon/LegendIcon';
import './Legend.css';
import classNames from 'classnames';
import { LegendProps, LegendTableType, LegendTypeType } from '../../types/components/legend';
import { SECOND_MAP_ID } from '../../constants/components/map';
import { updateLegendProperties } from './LegendUtils';


const Legend: React.FC<LegendProps> = ({isAllLayers, small, filterLayers, mapType}) => {

    const menu = useAtomValue(menuAtom);
    const selectedLayers = useAtomValue(selectedLayersAtom);
    const selectedSubMapLayers = useAtomValue(selectedSubMapLayersAtom);
    const [menuItems, setMenuItems] = useState<anyType[]| null>();
    const fiwareLegendData = useAtomValue(legendTableAtom);
    
    /* *****************************
     * 凡例に表示するアイテムをフィルタリング
     * *****************************/ 
    useEffect(() => {
        const filterLayers: string[] | undefined = mapType === SECOND_MAP_ID ? selectedSubMapLayers : selectedLayers;
        
        if(!menu || ((!isAllLayers && !filterLayers))) { return; }
        const items = [...walkCategories(menu)];
        let filterdItems = items;

        if(filterLayers && !isAllLayers) {
            filterdItems = items.filter((item) => filterLayers.includes(item.id));
        }
        setMenuItems(filterdItems);

    }, [menu, selectedLayers, selectedSubMapLayers, isAllLayers, filterLayers]);

    
    if(!menuItems) { return <></>; }

    return (
        <div className={classNames("legend", {'small': small})}>
            <div className='legend-list'>
                {
                    menuItems.map((item, index) => {
                        const {id, legendProperties} = updateLegendProperties(item, fiwareLegendData);

                        return (
                            <div key={`${id}-${index}`} className='legend-item'>
                                {/* ↓ タイトル部分 ↓ */}
                                <div className='data-name'>{item.id}</div>

                                {/* ↓ アイコン部分 ↓ */}
                                { legendProperties.legendTable ?
                                    // テーブル表示 
                                    <div className='data-legend'>
                                        { Object.keys(legendProperties.legendTable).map((key) => {
                                            const legend = (legendProperties.legendTable as LegendTableType)[key];
                                            return (
                                                <div key={key} className='item-children'>
                                                    <LegendIcon 
                                                        key={key}
                                                        type={Object.keys(legend)[0] as LegendTypeType}
                                                        value={Object.values(legend)[0] as string}
                                                        small={small}
                                                    />
                                                    { key !== 'isAlert' && <span>{key}</span> }
                                                </div>
                                            )
                                        })}
                                    </div>
                                    :
                                    // 通常表示
                                    <div className='data-legend'>
                                        { Object.keys(legendProperties).filter((key) => legendProperties[key] !== undefined).map((key) => {
                                            return (
                                                key === 'msg' ?
                                                <div key={key} className='item-children'>
                                                    { legendProperties[key] as string }
                                                </div>
                                                :
                                                <div key={key} className='item-children'>
                                                    <LegendIcon 
                                                        key={key}
                                                        type={key as LegendTypeType}
                                                        value={legendProperties[key] as string}
                                                        small={small}
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div> 
                                }
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default Legend;
